/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';
import { Route as AuthRouteImport } from './routes/auth';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index';
import { Route as AuthSignupRouteImport } from './routes/auth/signup';
import { Route as AuthSigninRouteImport } from './routes/auth/signin';
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password';
import { Route as AuthenticatedOwnerRouteImport } from './routes/_authenticated/$owner';
import { Route as AuthenticatedOwnerIndexRouteImport } from './routes/_authenticated/$owner/index';
import { Route as AuthenticatedOwnerSettingsRouteImport } from './routes/_authenticated/$owner/settings';
import { Route as AuthenticatedOwnerModelRouteImport } from './routes/_authenticated/$owner/$model';
import { Route as AuthenticatedOwnerSettingsIndexRouteImport } from './routes/_authenticated/$owner/settings/index';
import { Route as AuthenticatedOwnerModelIndexRouteImport } from './routes/_authenticated/$owner/$model/index';
import { Route as AuthenticatedOwnerSettingsSubscriptionRouteImport } from './routes/_authenticated/$owner/settings/subscription';
import { Route as AuthenticatedOwnerSettingsAccessRouteImport } from './routes/_authenticated/$owner/settings/access';
import { Route as AuthenticatedOwnerAccountSettingsRouteImport } from './routes/_authenticated/$owner/account/settings';
import { Route as AuthenticatedOwnerModelNewRouteImport } from './routes/_authenticated/$owner/$model/new';
import { Route as AuthenticatedOwnerAccountSettingsIndexRouteImport } from './routes/_authenticated/$owner/account/settings/index';
import { Route as AuthenticatedOwnerModelIdIndexRouteImport } from './routes/_authenticated/$owner/$model/$id.index';
import { Route as AuthenticatedOwnerAccountSettingsPasswordRouteImport } from './routes/_authenticated/$owner/account/settings/password';
import { Route as AuthenticatedOwnerModelIdEditRouteImport } from './routes/_authenticated/$owner/$model/$id.edit';

const AuthenticatedOwnerDesignLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design',
)();
const AuthenticatedOwnerDesignIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/',
)();
const AuthenticatedOwnerDesignTypographyLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/typography',
)();
const AuthenticatedOwnerDesignTablesLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/tables',
)();
const AuthenticatedOwnerDesignFormsLazyRouteImport = createFileRoute(
  '/_authenticated/$owner/design/forms',
)();

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any);
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any);
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any);
const AuthenticatedOwnerRoute = AuthenticatedOwnerRouteImport.update({
  id: '/$owner',
  path: '/$owner',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedOwnerIndexRoute = AuthenticatedOwnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerDesignLazyRoute =
  AuthenticatedOwnerDesignLazyRouteImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design.lazy').then((d) => d.Route),
  );
const AuthenticatedOwnerSettingsRoute =
  AuthenticatedOwnerSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerModelRoute = AuthenticatedOwnerModelRouteImport.update({
  id: '/$model',
  path: '/$model',
  getParentRoute: () => AuthenticatedOwnerRoute,
} as any);
const AuthenticatedOwnerDesignIndexLazyRoute =
  AuthenticatedOwnerDesignIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/index.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerSettingsIndexRoute =
  AuthenticatedOwnerSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerModelIndexRoute =
  AuthenticatedOwnerModelIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerModelRoute,
  } as any);
const AuthenticatedOwnerDesignTypographyLazyRoute =
  AuthenticatedOwnerDesignTypographyLazyRouteImport.update({
    id: '/typography',
    path: '/typography',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/typography.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignTablesLazyRoute =
  AuthenticatedOwnerDesignTablesLazyRouteImport.update({
    id: '/tables',
    path: '/tables',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/tables.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerDesignFormsLazyRoute =
  AuthenticatedOwnerDesignFormsLazyRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => AuthenticatedOwnerDesignLazyRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$owner/design/forms.lazy').then(
      (d) => d.Route,
    ),
  );
const AuthenticatedOwnerSettingsSubscriptionRoute =
  AuthenticatedOwnerSettingsSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerSettingsAccessRoute =
  AuthenticatedOwnerSettingsAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedOwnerSettingsRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsRoute =
  AuthenticatedOwnerAccountSettingsRouteImport.update({
    id: '/account/settings',
    path: '/account/settings',
    getParentRoute: () => AuthenticatedOwnerRoute,
  } as any);
const AuthenticatedOwnerModelNewRoute =
  AuthenticatedOwnerModelNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedOwnerModelRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsIndexRoute =
  AuthenticatedOwnerAccountSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerModelIdIndexRoute =
  AuthenticatedOwnerModelIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthenticatedOwnerModelRoute,
  } as any);
const AuthenticatedOwnerAccountSettingsPasswordRoute =
  AuthenticatedOwnerAccountSettingsPasswordRouteImport.update({
    id: '/password',
    path: '/password',
    getParentRoute: () => AuthenticatedOwnerAccountSettingsRoute,
  } as any);
const AuthenticatedOwnerModelIdEditRoute =
  AuthenticatedOwnerModelIdEditRouteImport.update({
    id: '/$id/edit',
    path: '/$id/edit',
    getParentRoute: () => AuthenticatedOwnerModelRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute;
  '/auth': typeof AuthRouteWithChildren;
  '/$owner': typeof AuthenticatedOwnerRouteWithChildren;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/$owner/$model': typeof AuthenticatedOwnerModelRouteWithChildren;
  '/$owner/settings': typeof AuthenticatedOwnerSettingsRouteWithChildren;
  '/$owner/design': typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  '/$owner/': typeof AuthenticatedOwnerIndexRoute;
  '/$owner/$model/new': typeof AuthenticatedOwnerModelNewRoute;
  '/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
  '/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/$owner/$model/': typeof AuthenticatedOwnerModelIndexRoute;
  '/$owner/settings/': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/$owner/design/': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/$owner/$model/$id/edit': typeof AuthenticatedOwnerModelIdEditRoute;
  '/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/$owner/$model/$id/': typeof AuthenticatedOwnerModelIdIndexRoute;
  '/$owner/account/settings/': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/$owner': typeof AuthenticatedOwnerIndexRoute;
  '/$owner/$model/new': typeof AuthenticatedOwnerModelNewRoute;
  '/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/$owner/$model': typeof AuthenticatedOwnerModelIndexRoute;
  '/$owner/settings': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/$owner/design': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/$owner/$model/$id/edit': typeof AuthenticatedOwnerModelIdEditRoute;
  '/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/$owner/$model/$id': typeof AuthenticatedOwnerModelIdIndexRoute;
  '/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/auth': typeof AuthRouteWithChildren;
  '/_authenticated/$owner': typeof AuthenticatedOwnerRouteWithChildren;
  '/auth/reset-password': typeof AuthResetPasswordRoute;
  '/auth/signin': typeof AuthSigninRoute;
  '/auth/signup': typeof AuthSignupRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/_authenticated/$owner/$model': typeof AuthenticatedOwnerModelRouteWithChildren;
  '/_authenticated/$owner/settings': typeof AuthenticatedOwnerSettingsRouteWithChildren;
  '/_authenticated/$owner/design': typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  '/_authenticated/$owner/': typeof AuthenticatedOwnerIndexRoute;
  '/_authenticated/$owner/$model/new': typeof AuthenticatedOwnerModelNewRoute;
  '/_authenticated/$owner/account/settings': typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
  '/_authenticated/$owner/settings/access': typeof AuthenticatedOwnerSettingsAccessRoute;
  '/_authenticated/$owner/settings/subscription': typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  '/_authenticated/$owner/design/forms': typeof AuthenticatedOwnerDesignFormsLazyRoute;
  '/_authenticated/$owner/design/tables': typeof AuthenticatedOwnerDesignTablesLazyRoute;
  '/_authenticated/$owner/design/typography': typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  '/_authenticated/$owner/$model/': typeof AuthenticatedOwnerModelIndexRoute;
  '/_authenticated/$owner/settings/': typeof AuthenticatedOwnerSettingsIndexRoute;
  '/_authenticated/$owner/design/': typeof AuthenticatedOwnerDesignIndexLazyRoute;
  '/_authenticated/$owner/$model/$id/edit': typeof AuthenticatedOwnerModelIdEditRoute;
  '/_authenticated/$owner/account/settings/password': typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  '/_authenticated/$owner/$model/$id/': typeof AuthenticatedOwnerModelIdIndexRoute;
  '/_authenticated/$owner/account/settings/': typeof AuthenticatedOwnerAccountSettingsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/auth'
    | '/$owner'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/$owner/$model'
    | '/$owner/settings'
    | '/$owner/design'
    | '/$owner/'
    | '/$owner/$model/new'
    | '/$owner/account/settings'
    | '/$owner/settings/access'
    | '/$owner/settings/subscription'
    | '/$owner/design/forms'
    | '/$owner/design/tables'
    | '/$owner/design/typography'
    | '/$owner/$model/'
    | '/$owner/settings/'
    | '/$owner/design/'
    | '/$owner/$model/$id/edit'
    | '/$owner/account/settings/password'
    | '/$owner/$model/$id/'
    | '/$owner/account/settings/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/auth'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/'
    | '/$owner'
    | '/$owner/$model/new'
    | '/$owner/settings/access'
    | '/$owner/settings/subscription'
    | '/$owner/design/forms'
    | '/$owner/design/tables'
    | '/$owner/design/typography'
    | '/$owner/$model'
    | '/$owner/settings'
    | '/$owner/design'
    | '/$owner/$model/$id/edit'
    | '/$owner/account/settings/password'
    | '/$owner/$model/$id'
    | '/$owner/account/settings';
  id:
    | '__root__'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/$owner'
    | '/auth/reset-password'
    | '/auth/signin'
    | '/auth/signup'
    | '/_authenticated/'
    | '/_authenticated/$owner/$model'
    | '/_authenticated/$owner/settings'
    | '/_authenticated/$owner/design'
    | '/_authenticated/$owner/'
    | '/_authenticated/$owner/$model/new'
    | '/_authenticated/$owner/account/settings'
    | '/_authenticated/$owner/settings/access'
    | '/_authenticated/$owner/settings/subscription'
    | '/_authenticated/$owner/design/forms'
    | '/_authenticated/$owner/design/tables'
    | '/_authenticated/$owner/design/typography'
    | '/_authenticated/$owner/$model/'
    | '/_authenticated/$owner/settings/'
    | '/_authenticated/$owner/design/'
    | '/_authenticated/$owner/$model/$id/edit'
    | '/_authenticated/$owner/account/settings/password'
    | '/_authenticated/$owner/$model/$id/'
    | '/_authenticated/$owner/account/settings/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  AuthRoute: typeof AuthRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth';
      path: '/auth';
      fullPath: '/auth';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/auth/signup': {
      id: '/auth/signup';
      path: '/signup';
      fullPath: '/auth/signup';
      preLoaderRoute: typeof AuthSignupRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/auth/signin': {
      id: '/auth/signin';
      path: '/signin';
      fullPath: '/auth/signin';
      preLoaderRoute: typeof AuthSigninRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/auth/reset-password': {
      id: '/auth/reset-password';
      path: '/reset-password';
      fullPath: '/auth/reset-password';
      preLoaderRoute: typeof AuthResetPasswordRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_authenticated/$owner': {
      id: '/_authenticated/$owner';
      path: '/$owner';
      fullPath: '/$owner';
      preLoaderRoute: typeof AuthenticatedOwnerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/$owner/': {
      id: '/_authenticated/$owner/';
      path: '/';
      fullPath: '/$owner/';
      preLoaderRoute: typeof AuthenticatedOwnerIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/design': {
      id: '/_authenticated/$owner/design';
      path: '/design';
      fullPath: '/$owner/design';
      preLoaderRoute: typeof AuthenticatedOwnerDesignLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/settings': {
      id: '/_authenticated/$owner/settings';
      path: '/settings';
      fullPath: '/$owner/settings';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/$model': {
      id: '/_authenticated/$owner/$model';
      path: '/$model';
      fullPath: '/$owner/$model';
      preLoaderRoute: typeof AuthenticatedOwnerModelRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/design/': {
      id: '/_authenticated/$owner/design/';
      path: '/';
      fullPath: '/$owner/design/';
      preLoaderRoute: typeof AuthenticatedOwnerDesignIndexLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/settings/': {
      id: '/_authenticated/$owner/settings/';
      path: '/';
      fullPath: '/$owner/settings/';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/$model/': {
      id: '/_authenticated/$owner/$model/';
      path: '/';
      fullPath: '/$owner/$model/';
      preLoaderRoute: typeof AuthenticatedOwnerModelIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerModelRoute;
    };
    '/_authenticated/$owner/design/typography': {
      id: '/_authenticated/$owner/design/typography';
      path: '/typography';
      fullPath: '/$owner/design/typography';
      preLoaderRoute: typeof AuthenticatedOwnerDesignTypographyLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/tables': {
      id: '/_authenticated/$owner/design/tables';
      path: '/tables';
      fullPath: '/$owner/design/tables';
      preLoaderRoute: typeof AuthenticatedOwnerDesignTablesLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/design/forms': {
      id: '/_authenticated/$owner/design/forms';
      path: '/forms';
      fullPath: '/$owner/design/forms';
      preLoaderRoute: typeof AuthenticatedOwnerDesignFormsLazyRouteImport;
      parentRoute: typeof AuthenticatedOwnerDesignLazyRoute;
    };
    '/_authenticated/$owner/settings/subscription': {
      id: '/_authenticated/$owner/settings/subscription';
      path: '/subscription';
      fullPath: '/$owner/settings/subscription';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/settings/access': {
      id: '/_authenticated/$owner/settings/access';
      path: '/access';
      fullPath: '/$owner/settings/access';
      preLoaderRoute: typeof AuthenticatedOwnerSettingsAccessRouteImport;
      parentRoute: typeof AuthenticatedOwnerSettingsRoute;
    };
    '/_authenticated/$owner/account/settings': {
      id: '/_authenticated/$owner/account/settings';
      path: '/account/settings';
      fullPath: '/$owner/account/settings';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsRouteImport;
      parentRoute: typeof AuthenticatedOwnerRoute;
    };
    '/_authenticated/$owner/$model/new': {
      id: '/_authenticated/$owner/$model/new';
      path: '/new';
      fullPath: '/$owner/$model/new';
      preLoaderRoute: typeof AuthenticatedOwnerModelNewRouteImport;
      parentRoute: typeof AuthenticatedOwnerModelRoute;
    };
    '/_authenticated/$owner/account/settings/': {
      id: '/_authenticated/$owner/account/settings/';
      path: '/';
      fullPath: '/$owner/account/settings/';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/$model/$id/': {
      id: '/_authenticated/$owner/$model/$id/';
      path: '/$id';
      fullPath: '/$owner/$model/$id/';
      preLoaderRoute: typeof AuthenticatedOwnerModelIdIndexRouteImport;
      parentRoute: typeof AuthenticatedOwnerModelRoute;
    };
    '/_authenticated/$owner/account/settings/password': {
      id: '/_authenticated/$owner/account/settings/password';
      path: '/password';
      fullPath: '/$owner/account/settings/password';
      preLoaderRoute: typeof AuthenticatedOwnerAccountSettingsPasswordRouteImport;
      parentRoute: typeof AuthenticatedOwnerAccountSettingsRoute;
    };
    '/_authenticated/$owner/$model/$id/edit': {
      id: '/_authenticated/$owner/$model/$id/edit';
      path: '/$id/edit';
      fullPath: '/$owner/$model/$id/edit';
      preLoaderRoute: typeof AuthenticatedOwnerModelIdEditRouteImport;
      parentRoute: typeof AuthenticatedOwnerModelRoute;
    };
  }
}

interface AuthenticatedOwnerModelRouteChildren {
  AuthenticatedOwnerModelNewRoute: typeof AuthenticatedOwnerModelNewRoute;
  AuthenticatedOwnerModelIndexRoute: typeof AuthenticatedOwnerModelIndexRoute;
  AuthenticatedOwnerModelIdEditRoute: typeof AuthenticatedOwnerModelIdEditRoute;
  AuthenticatedOwnerModelIdIndexRoute: typeof AuthenticatedOwnerModelIdIndexRoute;
}

const AuthenticatedOwnerModelRouteChildren: AuthenticatedOwnerModelRouteChildren =
  {
    AuthenticatedOwnerModelNewRoute: AuthenticatedOwnerModelNewRoute,
    AuthenticatedOwnerModelIndexRoute: AuthenticatedOwnerModelIndexRoute,
    AuthenticatedOwnerModelIdEditRoute: AuthenticatedOwnerModelIdEditRoute,
    AuthenticatedOwnerModelIdIndexRoute: AuthenticatedOwnerModelIdIndexRoute,
  };

const AuthenticatedOwnerModelRouteWithChildren =
  AuthenticatedOwnerModelRoute._addFileChildren(
    AuthenticatedOwnerModelRouteChildren,
  );

interface AuthenticatedOwnerSettingsRouteChildren {
  AuthenticatedOwnerSettingsAccessRoute: typeof AuthenticatedOwnerSettingsAccessRoute;
  AuthenticatedOwnerSettingsSubscriptionRoute: typeof AuthenticatedOwnerSettingsSubscriptionRoute;
  AuthenticatedOwnerSettingsIndexRoute: typeof AuthenticatedOwnerSettingsIndexRoute;
}

const AuthenticatedOwnerSettingsRouteChildren: AuthenticatedOwnerSettingsRouteChildren =
  {
    AuthenticatedOwnerSettingsAccessRoute:
      AuthenticatedOwnerSettingsAccessRoute,
    AuthenticatedOwnerSettingsSubscriptionRoute:
      AuthenticatedOwnerSettingsSubscriptionRoute,
    AuthenticatedOwnerSettingsIndexRoute: AuthenticatedOwnerSettingsIndexRoute,
  };

const AuthenticatedOwnerSettingsRouteWithChildren =
  AuthenticatedOwnerSettingsRoute._addFileChildren(
    AuthenticatedOwnerSettingsRouteChildren,
  );

interface AuthenticatedOwnerDesignLazyRouteChildren {
  AuthenticatedOwnerDesignFormsLazyRoute: typeof AuthenticatedOwnerDesignFormsLazyRoute;
  AuthenticatedOwnerDesignTablesLazyRoute: typeof AuthenticatedOwnerDesignTablesLazyRoute;
  AuthenticatedOwnerDesignTypographyLazyRoute: typeof AuthenticatedOwnerDesignTypographyLazyRoute;
  AuthenticatedOwnerDesignIndexLazyRoute: typeof AuthenticatedOwnerDesignIndexLazyRoute;
}

const AuthenticatedOwnerDesignLazyRouteChildren: AuthenticatedOwnerDesignLazyRouteChildren =
  {
    AuthenticatedOwnerDesignFormsLazyRoute:
      AuthenticatedOwnerDesignFormsLazyRoute,
    AuthenticatedOwnerDesignTablesLazyRoute:
      AuthenticatedOwnerDesignTablesLazyRoute,
    AuthenticatedOwnerDesignTypographyLazyRoute:
      AuthenticatedOwnerDesignTypographyLazyRoute,
    AuthenticatedOwnerDesignIndexLazyRoute:
      AuthenticatedOwnerDesignIndexLazyRoute,
  };

const AuthenticatedOwnerDesignLazyRouteWithChildren =
  AuthenticatedOwnerDesignLazyRoute._addFileChildren(
    AuthenticatedOwnerDesignLazyRouteChildren,
  );

interface AuthenticatedOwnerAccountSettingsRouteChildren {
  AuthenticatedOwnerAccountSettingsPasswordRoute: typeof AuthenticatedOwnerAccountSettingsPasswordRoute;
  AuthenticatedOwnerAccountSettingsIndexRoute: typeof AuthenticatedOwnerAccountSettingsIndexRoute;
}

const AuthenticatedOwnerAccountSettingsRouteChildren: AuthenticatedOwnerAccountSettingsRouteChildren =
  {
    AuthenticatedOwnerAccountSettingsPasswordRoute:
      AuthenticatedOwnerAccountSettingsPasswordRoute,
    AuthenticatedOwnerAccountSettingsIndexRoute:
      AuthenticatedOwnerAccountSettingsIndexRoute,
  };

const AuthenticatedOwnerAccountSettingsRouteWithChildren =
  AuthenticatedOwnerAccountSettingsRoute._addFileChildren(
    AuthenticatedOwnerAccountSettingsRouteChildren,
  );

interface AuthenticatedOwnerRouteChildren {
  AuthenticatedOwnerModelRoute: typeof AuthenticatedOwnerModelRouteWithChildren;
  AuthenticatedOwnerSettingsRoute: typeof AuthenticatedOwnerSettingsRouteWithChildren;
  AuthenticatedOwnerDesignLazyRoute: typeof AuthenticatedOwnerDesignLazyRouteWithChildren;
  AuthenticatedOwnerIndexRoute: typeof AuthenticatedOwnerIndexRoute;
  AuthenticatedOwnerAccountSettingsRoute: typeof AuthenticatedOwnerAccountSettingsRouteWithChildren;
}

const AuthenticatedOwnerRouteChildren: AuthenticatedOwnerRouteChildren = {
  AuthenticatedOwnerModelRoute: AuthenticatedOwnerModelRouteWithChildren,
  AuthenticatedOwnerSettingsRoute: AuthenticatedOwnerSettingsRouteWithChildren,
  AuthenticatedOwnerDesignLazyRoute:
    AuthenticatedOwnerDesignLazyRouteWithChildren,
  AuthenticatedOwnerIndexRoute: AuthenticatedOwnerIndexRoute,
  AuthenticatedOwnerAccountSettingsRoute:
    AuthenticatedOwnerAccountSettingsRouteWithChildren,
};

const AuthenticatedOwnerRouteWithChildren =
  AuthenticatedOwnerRoute._addFileChildren(AuthenticatedOwnerRouteChildren);

interface AuthenticatedRouteChildren {
  AuthenticatedOwnerRoute: typeof AuthenticatedOwnerRouteWithChildren;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOwnerRoute: AuthenticatedOwnerRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface AuthRouteChildren {
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute;
  AuthSigninRoute: typeof AuthSigninRoute;
  AuthSignupRoute: typeof AuthSignupRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
